import "../../styles/UserDashboard/EnergyOverview.scss";
import SideBar from "../../components/UserDashboard/SideBar";
import { useEffect, useState } from "react";
import EnergyHeader from "../../components/energy/energyHeader";
import EnergyTransferred from "../../components/energy/EnergyTransferred";
import BuyerConfirmed from "../../components/energy/BuyerConfirmed";
import SellerConfirmed from "../../components/energy/SellerConfirmed";
import { useNavigate } from "react-router-dom";
import { EnergyTradingIntegration } from "../../instantiateTransaction/EnergySharing";
import { useSelector } from "react-redux";
import { getUserInfo } from "../../apis/General/users";
import { getEnergyListed } from "../../apis/energySharing";

import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
} from "firebase/database";
import WithdrawalModal from "../../components/energy/withdrawalModal";
import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png";
import formatDate from "../../utils/formatDate";
export default function EnergyOverviewOpen() {
  const auth = useSelector((state) => state.auth);
  console.log("auth", auth);

  const [generalLoading, setGeneralLoading] = useState(false);
  const [transferredOpen, setTransferredOpen] = useState(false);
  const [buyerConfirmedOpen, setBuyerConfirmedOpen] = useState(false);
  const [sellerConfirmedOpen, setSellerConfirmedOpen] = useState(false);
  const [paymentReceived, setPaymentReceived] = useState(false);
  const [surplusEnergy, setSurplusEnergy] = useState(0);
  const [frozen, setFrozen] = useState(false);
  const [energyData, setEnergyData] = useState(0);
  const [transferred, setTransferred] = useState(false);
  const [withdrawalOpen, setWithdrawalOpen] = useState(false);
  const [energyListed, setEnergyListed] = useState(0);

  const navigate = useNavigate();

  const handleFrozenClick = () => {
    if (frozen) {
      setTransferredOpen(true);
    } else {
      setFrozen(true);
    }
  };

  const handleGetEnergyBalance = async () => {
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log("getUserInfo", response);

    if (response?.data?.statusCode === 200) {
      const integration = new EnergyTradingIntegration();
      await integration.init();
      const walletAddress = response?.data?.message?.walletAddress;
      const balance = await integration.getEnergyUnitBalance(walletAddress);
      setSurplusEnergy(balance);
    }
  };

  useEffect(() => {
    handleGetEnergyBalance();
  }, []);

  // console.log('mice', localStorage.getItem('kycCompleted') === "complete");
  const db = getDatabase();

    const loadEvents = async () => {
  
      const newRef = ref(db, "dev-energy-sharing-table");
       onValue(newRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = Object.values(snapshot.val());
          console.log('devices found', data);
          setEnergyData(data)
         
        } else {
          console.log(`No data found`);
        }
      });
    };
  
    useEffect(() => {
      loadEvents()
    }, [])

    useEffect(() => {
      const fetchEnergyListed = async () => {
        const response = await getEnergyListed(auth?.userInfo?.id, auth?.token);
        console.log("getEnergyListed:", response);
        const listed = response?.data?.message?.energyListed || 0;
        setEnergyListed(listed);
      };
      fetchEnergyListed();
    }, [auth?.userInfo?.id, auth?.token]);
    

  return (
    <div className="energyOverview">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="energyOverview__inner">

        <div className="energyOverview__inner__open-header">
    <div>
      <div className="energyOverview__inner__open-header__title">Good Morning</div>
      <div className="energyOverview__inner__open-header__subtitle">Ololade Grace</div>
    </div>
    <img
                src={Logo}
                alt=""
                className="pointer"
                // onClick={() => navigate("/dashboard")}
              />
        </div>
        <div
          className={`energyOverview__inner__cards ${
            frozen || !transferred ? "energyOverview__inner__cards-frozen" : ""
          }`}
        >
          <div className="energyOverview__inner__cards__card">
            <div className="energyOverview__inner__cards__card__title">
              Total Generated Energy
            </div>
            <div className="energyOverview__inner__cards__card__subtitle">
              {energyData[energyData?.length - 1]?.energyAvailable || 0} <span>kWh</span>
            </div>

            <div className="energyOverview__inner__cards__card__subsubtitle">
              <div>Compared to yesterday</div>

              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_4956_26756"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4956_26756)">
                    <path
                      d="M2.26634 12L1.33301 11.0667L4.86634 7.53333C5.25523 7.14444 5.72745 6.95 6.28301 6.95C6.83856 6.95 7.31079 7.14444 7.69967 7.53333L8.46634 8.3C8.59967 8.43333 8.75801 8.5 8.94134 8.5C9.12467 8.5 9.28301 8.43333 9.41634 8.3L12.383 5.33333H10.6663V4H14.6663V8H13.333V6.28333L10.3497 9.25C9.96079 9.63889 9.48856 9.83333 8.93301 9.83333C8.37745 9.83333 7.90523 9.63889 7.51634 9.25L6.73301 8.46667C6.61079 8.34444 6.45523 8.28333 6.26634 8.28333C6.07745 8.28333 5.9219 8.34444 5.79967 8.46667L2.26634 12Z"
                      fill="#0F973D"
                    />
                  </g>
                </svg>
                <div>+15%</div>
              </div>
            </div>
          </div>
          <div className="energyOverview__inner__cards__card">
            <div className="energyOverview__inner__cards__card__title">
              Energy Consumed
            </div>
            <div className="energyOverview__inner__cards__card__subtitle">
              10,450 <span>kWh</span>
            </div>
            <div className="energyOverview__inner__cards__card__subsubtitle">
              <div>Compared to yesterday</div>

              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_4956_26756"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4956_26756)">
                    <path
                      d="M2.26634 12L1.33301 11.0667L4.86634 7.53333C5.25523 7.14444 5.72745 6.95 6.28301 6.95C6.83856 6.95 7.31079 7.14444 7.69967 7.53333L8.46634 8.3C8.59967 8.43333 8.75801 8.5 8.94134 8.5C9.12467 8.5 9.28301 8.43333 9.41634 8.3L12.383 5.33333H10.6663V4H14.6663V8H13.333V6.28333L10.3497 9.25C9.96079 9.63889 9.48856 9.83333 8.93301 9.83333C8.37745 9.83333 7.90523 9.63889 7.51634 9.25L6.73301 8.46667C6.61079 8.34444 6.45523 8.28333 6.26634 8.28333C6.07745 8.28333 5.9219 8.34444 5.79967 8.46667L2.26634 12Z"
                      fill="#0F973D"
                    />
                  </g>
                </svg>
                <div>+15%</div>
              </div>
            </div>
          </div>
          <div className="energyOverview__inner__cards__card"
          onClick={() => setPaymentReceived(true)}
          >
            <div className="energyOverview__inner__cards__card__title">
              Surplus Energy
            </div>
            <div className="energyOverview__inner__cards__card__subtitle">
              {surplusEnergy} <span>kWh</span>
            </div>
            <div className="energyOverview__inner__cards__card__subsubtitle">
              <div>Compared to yesterday</div>

              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_4956_26756"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="16"
                  >
                    <rect width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4956_26756)">
                    <path
                      d="M2.26634 12L1.33301 11.0667L4.86634 7.53333C5.25523 7.14444 5.72745 6.95 6.28301 6.95C6.83856 6.95 7.31079 7.14444 7.69967 7.53333L8.46634 8.3C8.59967 8.43333 8.75801 8.5 8.94134 8.5C9.12467 8.5 9.28301 8.43333 9.41634 8.3L12.383 5.33333H10.6663V4H14.6663V8H13.333V6.28333L10.3497 9.25C9.96079 9.63889 9.48856 9.83333 8.93301 9.83333C8.37745 9.83333 7.90523 9.63889 7.51634 9.25L6.73301 8.46667C6.61079 8.34444 6.45523 8.28333 6.26634 8.28333C6.07745 8.28333 5.9219 8.34444 5.79967 8.46667L2.26634 12Z"
                      fill="#0F973D"
                    />
                  </g>
                </svg>
                <div>+15%</div>
              </div>
            </div>
          </div>
          
        </div>

        

        <div className="management_card_group">
          <div className="card1">
            <div className="title_group">
              <div>Energy Consumption</div>
              <div className="title_group__flex"></div>

              {/* <form className="date_group">
                    <div>
                      <div>From</div>
                      <input
                        type="date"
                        value={from}
                        onChange={handleFromChange}
                      />
                      {inRangeLoading && <div>Loading...</div>}
                    </div>
                    <div>
                      <div>To</div>
                      <input type="date" value={to} onChange={handleToChange} />
                    </div>
                  </form> */}
            </div>

            <div className="emission_table" id="table">
              {!generalLoading && (
                <div className="table_header_container">
                  <div className="table_header first">Time (AM/PM)</div>
                  <div className="table_header">Energy (kWh)</div>
                  <div className="table_header">Power output (kW)</div>
                  <div className="table_header last">Source</div>
                </div>
              )}
              {generalLoading ? (
                <>
                  {/* <Skeleton
                        height={40}
                        borderRadius={4}
                        count={5}
                        style={{ marginTop: "24px" }}
                      /> */}
                </>
              ) : (
                <>
                  <>
                    <div className="table_body_container">
                      <div>09:20am</div>
                      <div>900</div>
                      <div>2,727.27</div>
                      <div>Solar</div>
                    </div>
                    <div className="table_body_container mobile">
                      <div>09:20am</div>
                      <div>900</div>
                      <div>2,727.27</div>
                      <div>Solar</div>
                    </div>
                  </>
                </>
              )}
            </div>
          </div>
          <div className="card2"></div>
        </div>

        <div className="energyOverview__inner__note">
          <div>Note:</div>
          <div>
          For detailed insights into your energy consumption, total energy generated, and more, Login to your portal to explore the full experience.
          </div>
        </div>
      </div>

      <EnergyTransferred
        title="Congratulations"
        subtitle= "Your 800kWh energy has been unlocked and successfully transferred. Check your wallet balance for payment."
        open={transferredOpen}
        setOpen={setTransferredOpen}
        onConfirm={() => setTransferred(true)}
      />
      <BuyerConfirmed
        open={buyerConfirmedOpen}
        setOpen={setBuyerConfirmedOpen}
        onConfirm={() => setTransferred(true)}
      />
      <SellerConfirmed
        title="You’ve gotten a seller"
        subtitle= "A seller has agreed to provide 800kwh of energy. Proceed to complete the transaction."
        buttonTexts={["Cancel", "Proceed"]}
        buttonFunctions={[
          () => setSellerConfirmedOpen(false),
          () => navigate("/pay-for-energy"),
        ]}
        open={sellerConfirmedOpen}
        setOpen={setSellerConfirmedOpen}
      />
      <SellerConfirmed
        title="Have you received payment?"
        subtitle="Click yes if you have received payment for the energy."
        buttonTexts={["Cancel", "Yes"]}
        buttonFunctions={[
          () => setPaymentReceived(false),
          () => setPaymentReceived(false),
        ]}
        open={paymentReceived}
        setOpen={setPaymentReceived}
      />
      <WithdrawalModal open={withdrawalOpen} setOpen={setWithdrawalOpen} />
    </div>
  );
}
